const TicketsSection = (gsap) => {
	const ticketsBlock = document.querySelector(".tickets-block");

	if(!ticketsBlock) return;

	let image1 = document.querySelector(".tickets-image-1");
	let image2 = document.querySelector(".tickets-image-2");
	let image3 = document.querySelector(".tickets-image-3");

	gsap.to(image1, {
		xPercent: 5,
		ease: "none",
		scrollTrigger: {
			trigger: ".tickets-block",
			start: "top center", // the default values
			// end: "+=" + 2000,
			scrub: true,
		},
	});
	gsap.to(image2, {
		xPercent: -10,
		ease: "none",
		scrollTrigger: {
			trigger: ".tickets-block",
			start: "top center", // the default values
			// end: "+=" + 2000,
			scrub: true,
		},
	});
	gsap.to(image3, {
		xPercent: 15,
		ease: "none",
		scrollTrigger: {
			trigger: ".tickets-block",
			start: "top center", // the default values
			// end: "+=" + 2000,
			scrub: true,
		},
	});
};

export default TicketsSection;
